import { useState } from 'react';
import { toast } from 'sonner';
import { auditoriaProveedoresApi } from '../../../lib/api';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { Check, EyeOff, AlertTriangle } from 'lucide-react';
import { IgnorarDialog } from './IgnorarDialog';

const ORIGEN_LABEL = { alegra_contacts: 'Maestro Alegra', proveedores: 'Maestro ERP', oc: 'OC' };

const FilaRut = ({ d, onChange }) => {
  const [busy, setBusy] = useState(false);
  const [ignorar, setIgnorar] = useState(false);

  const corregir = async () => {
    setBusy(true);
    try {
      const r = await auditoriaProveedoresApi.corregir(d.id);
      toast.success(`RUT corregido: ${r.data.rut}`, { description: r.data.acciones.join(' · ') });
      onChange();
    } catch (e) {
      toast.error('No se pudo corregir el RUT', { description: e.response?.data?.detail || e.message });
    } finally {
      setBusy(false);
    }
  };

  return (
    <tr className="border-b hover:bg-muted/40" data-testid={`fila-rut-${d.origen}-${d.ref}`}>
      <td className="p-2 text-xs"><Badge variant="outline">{ORIGEN_LABEL[d.origen] || d.origen}{d.origen === 'oc' ? ` ${d.ref}` : ''}</Badge></td>
      <td className="p-2 text-sm">{d.nombre_erp || <span className="text-muted-foreground">(sin nombre)</span>}</td>
      <td className="p-2 font-mono text-xs text-red-700" data-testid="rut-erp">{d.rut_erp || '(vacío)'}</td>
      <td className="p-2 font-mono text-xs" data-testid="rut-canonico">
        {d.rut_canonico || <span className="text-amber-700 inline-flex items-center gap-1"><AlertTriangle className="w-3 h-3" /> inválido: {d.motivo}</span>}
        {d.ultimo_error && <div className="text-[10px] text-red-600 font-sans mt-0.5">{d.ultimo_error}</div>}
      </td>
      <td className="p-2 whitespace-nowrap">
        <div className="flex gap-1">
          <Button size="sm" onClick={corregir} disabled={busy || !d.rut_canonico} data-testid="btn-corregir-rut">
            <Check className="w-4 h-4 mr-1" /> Corregir
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setIgnorar(true)} disabled={busy} title="Ignorar" data-testid="btn-ignorar-rut">
            <EyeOff className="w-4 h-4" />
          </Button>
        </div>
        <IgnorarDialog open={ignorar} onOpenChange={setIgnorar} id={d.id} descripcion={`${d.rut_erp} · ${d.nombre_erp}`} onDone={onChange} />
      </td>
    </tr>
  );
};

export const TablaRut = ({ items, onChange }) => {
  if (!items.length) return <p className="text-sm text-muted-foreground py-8 text-center" data-testid="tabla-rut-vacio">Todos los RUT cumplen el formato 00000000-A.</p>;
  return (
    <div className="overflow-x-auto rounded-md border">
      <table className="w-full text-sm" data-testid="tabla-rut">
        <thead className="bg-muted/60 text-xs uppercase text-muted-foreground">
          <tr>
            <th className="p-2 text-left">Dónde</th>
            <th className="p-2 text-left">Proveedor</th>
            <th className="p-2 text-left">RUT actual</th>
            <th className="p-2 text-left">RUT correcto</th>
            <th className="p-2 text-left">Acción</th>
          </tr>
        </thead>
        <tbody>{items.map((d) => <FilaRut key={d.id} d={d} onChange={onChange} />)}</tbody>
      </table>
    </div>
  );
};
